import "core-js/modules/es6.number.constructor";
import _defineProperty from "E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "MobileQuickService",
  props: {
    navList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    cssVars: function cssVars() {
      return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
        "--mqs-spacing": "16px",
        "--mqs-radius": "12px",
        "--mqs-text": "#112c63",
        "--mqs-title-color": "#133583",
        "--mqs-desc-color": "#90A1C7",
        "--mqs-shadow": "0 2px 12px 0 rgba(10, 61, 145, 0.08)",
        "--mqs-padding-top": "20px",
        "--mqs-section-title-font-size": "18px",
        "--mqs-section-title-mb": "12px",
        "--mqs-grid-gap": "10px",
        "--mqs-grid-mt": "10px",
        // shared card vars
        "--mqs-card-height": "110px",
        "--mqs-card-padding": "12px",
        "--mqs-card-gap": "6px"
      }, "--mqs-title-color", "#133583"), "--mqs-desc-color", "#90A1C7"), "--mqs-hero-title-font-size", "18px"), "--mqs-hero-num-font-size", "22px"), "--mqs-hero-label-font-size", "13px"), "--mqs-card-title-font-size", "15px"), "--mqs-card-num-font-size", "20px"), "--mqs-card-desc-font-size", "13px");
    }
  },
  methods: {
    getBgImg: function getBgImg(index) {
      try {
        return require("@/assets/home_phone/kjfw_".concat(index + 1, ".png"));
      } catch (e) {
        return "";
      }
    },
    getTotalCount: function getTotalCount(item) {
      if (!item.resourceTypeTotal || item.resourceTypeTotal.length === 0) return 0;
      return item.resourceTypeTotal.reduce(function (sum, r) {
        return sum + (Number(r.total) || 0);
      }, 0);
    },
    handleClick: function handleClick(item) {
      var query = item.type === "2" ? {
        pushObjectId: item.id,
        courseType: "14"
      } : item.type === "1" ? {
        pushObjectId: item.id
      } : {};
      this.$router.push({
        path: item.url,
        query: query
      });
    }
  }
};